var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"icon"},[_c('BaseSpinner',{attrs:{"size":"32px","brand":""}})],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('p',[_vm._v(" Идет перенаправление на платформу Яндекс.Контест. Пожалуйста, подождите... ")])])
}]

export { render, staticRenderFns }